<script setup lang="ts">
import { locale_float } from '~/types/shared';
const { t } = useI18n();
// const isOpen = defineModel<boolean>({
//     required: true,
// });
// const { user } = defineProps<{
//     user: any;
// }>();
const authStore = useAuthStore();
const { selectedUser: user, isUserInfoOpen: isOpen } = storeToRefs(authStore);
const firstName = computed(() => user.value?.tg?.first_name || '');
const lastName = computed(() => user.value?.tg?.last_name || '');
const fullName = computed(() => `${firstName.value} ${lastName.value}`.trim());
const username = computed(() => user.value?.tg?.username);

const close = () => {
    isOpen.value = false;
};
const activeTab = ref(0);
const tabs = ref([
    {
        label: t('transaktsii'),
        slot: 'transactions',
    },
    {
        label: t('cards'),
        slot: 'cards',
    },
    {
        label: t('cards_issue_orders'),
        slot: 'cards_issue_orders',
    },
    {
        label: t('cards_topup_orders'),
        slot: 'cards_topup_orders',
    },
]);

const userId = computed(() => user.value?._id?.$oid || '');
</script>
<template>
    <UModal v-model="isOpen" :ui="{ width: 'w-full sm:max-w-7xl' }">
        <UCard :ui="{ divide: 'divide-y divide-gray-100 dark:divide-gray-800' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-xl font-bold text-gray-900 dark:text-gray-400">
                             <div class="flex items-center space-x-2" v-if="user?.tg">
                                <div class="text-zinc-800 dark:text-zinc-300">
                                    <div>
                                    {{ fullName }}
                                    <ULink v-if="username" :to="`https://t.me/${username}`" target="_blank" @click.stop>
                                    (@{{ username }})
                                    </ULink>
                                </div>
                                    id: {{ userId }}
                                </div>
                             </div>
                             <div v-else>
                                {{ $t('polzovatel') }}
                            </div>
                    </h3>
                    <UButton
                        color="gray"
                        variant="ghost"
                        icon="i-heroicons-x-mark-20-solid"
                        class="-my-1"
                        @click="close"
                    />
                </div>
            </template>
            <template #default>
                <div class="flex items-center justify-between mb-4">
                    <div class="flex flex-col gap-1 justify-center">
                        <span>{{ t('created_at') }}</span>
                        <span>{{ $dayjs(user?.created_at?.$date).format('L, LT') }}</span>
                    </div>
                    <div  class="flex flex-col gap-1 justify-center">
                        <span>{{ t('tma_last_activity_at') }}</span>
                        <div class="space-y-2">
						<div v-if="user?.tma_last_activity_at">
							<div class="text-zinc-800 dark:text-zinc-300" >{{ $dayjs(user.tma_last_activity_at.$date).fromNow() }}</div>
						</div>
                        <div v-else class="text-zinc-500 dark:text-zinc-400">{{ t('net_dannih') }}</div>
					</div>
                    </div>
                    <div  class="flex flex-col gap-1 justify-center">
                        <span>{{ t('istoch') }}</span>
           				<div v-if="user?.register_start_params?.source" class="text-zinc-800 dark:text-zinc-300">{{ user.register_start_params?.source }}</div>
                        <div v-else class="text-zinc-500 dark:text-zinc-400">{{ t('net_dannih') }}</div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <span>  {{ t('balance') }} </span>
                        <div v-if="user?.usdt_balance" class="flex items-center space-x-2">
						    <UIcon name="i-cryptocurrency-usdt" class="w-5 h-5 text-green-600"/>
						    <div class="text-zinc-800 dark:text-zinc-300 font-mono text-lg">{{ locale_float(user?.usdt_balance || NaN) }}</div>
					    </div>
                        <div v-else class="text-zinc-500 dark:text-zinc-400">{{ t('net_dannih') }}</div>    
                    </div>
                    <div class="flex flex-col gap-1">
                        <span> {{ t('wallets') }}</span>
                        <div class="flex items-center space-x-2" v-if="user?.wallet_data">
                            <div class="flex items-center space-x-2" v-for="(wallet, index) in user?.wallet_data" :key="index">
                                <UIcon name="i-cryptocurrency-color-trx" class="w-5 h-5"/>
                                <div class="space-y-2 flex flex-col">
                                    <ULink :to="`https://tronscan.org/#/address/${wallet.address}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ wallet.address }}</ULink>
                                </div>
                            </div>
					    </div>
                        <div v-else class="text-zinc-500 dark:text-zinc-400">{{ t('net_dannih') }}</div>
                    </div>
                </div>
                <UTabs :items="tabs" v-model="activeTab">
                    <template #transactions>
                        <UserTxsTable  :user-id="userId" />
                    </template>
                    <template #cards>
                        <UserCardsTable :user-id="userId" />
                    </template>
                    <template #cards_issue_orders>
                        <UserCardIssueOrdersTable :user-id="userId" />
                    </template>
                    <template #cards_topup_orders>
                        <UserCardTopupOrdersTable :user-id="userId" />
                    </template>
                </UTabs>
            </template>
        </UCard>
    </UModal>
</template>
